import Vue from "vue";
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import 'jquery';
import "./registerServiceWorker";
import './validationRules'
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);

// Instances
import App from "./App.vue";
import store from "./store";
import router from './router';

import { initListener } from './store/offlineHelper';
import i18n from './translations'
import { apolloClient, Cache} from './services/apollo'

// Libs
import { persistCache } from 'apollo-cache-persist';
import VueApollo from 'vue-apollo';
import VueCurrencyInput from 'vue-currency-input'
import VueRouter from 'vue-router';
import Vuelidate from "vuelidate";
import Vue2TouchEvents from 'vue2-touch-events'
import VueSimpleAlert from "vue-simple-alert";
import Notifications from 'vue-notification'
import LoadingPlugin from "vue-loading-overlay";



// VatVies('PL')

const pluginOptionsCurrency = {
    /* see config reference */
    globalOptions: { currency: 'PLN', locale: 'PL' }
}
Vue.use(VueCurrencyInput, pluginOptionsCurrency);

Vue.use(Vue2TouchEvents)
Vue.use(Notifications)

persistCache({
    cache: Cache,
    storage: window.localStorage,
}).then(() => {
    // Vue Plugins
    Vue.use(Vuelidate);
    Vue.use(VueRouter);
    Vue.use(VueApollo);
    Vue.use(VueSimpleAlert);
    Vue.use(LoadingPlugin);

    Vue.filter("currency", value =>
        new Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN" }).format(
            value
        )
    );
    Vue.config.productionTip = false;
    new Vue({
        router,
        store,
        i18n,
        apolloProvider: new VueApollo({
            defaultClient: apolloClient
        }),
        render: h => h(App)
    }).$mount("#app");
    initListener();
})
